import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GeographiesService } from 'projects/services/src/app/API/geographies.service';
declare var toastr;
const DEFAULT_OPTIONS = {
		edit: true,
		delete: true,
		add: true,
		required: false,
	};
@Component({
  selector: 'app-select-state-districts',
  templateUrl: './select-state-districts.component.html',
  styleUrls: ['./select-state-districts.component.css']
})

export class SelectStateDistrictsComponent implements OnInit {
	@Input() formLable: string;
	formGroup: FormGroup;
	@Input() inputLabel: string;
	@Input() tableLabel: string;
	@Output() control = new EventEmitter();
	@Input() selectStateError = false;
	totalStates: any;
	editStateRule: any = false;
	selectedEditState: any;
	totalDistricts: any;
	editStateIndex: any;
	@Input() rules: any= [];
	disableDistricts: boolean;
	enableAddButton: boolean;
	editDisable = false;
	@Input() options = DEFAULT_OPTIONS;
  constructor(
	  private formBuilder: FormBuilder,
	  private geographyService: GeographiesService,
  ) {
		this.createformGroup();
   }

	// create candidate Form
	createformGroup() {
		this.formGroup = this.formBuilder.group({
			state: ['', Validators.required],
			districts: [''],
		});
	}
	// get all states available
	getAllStates() {
		this.geographyService.getStates().subscribe(res => {
			this.totalStates = res.states;
		},
			(err => {
				console.log(err);
			}));
	}



	editRule(stateIndex, ruleData) {
		this.editStateRule = true;
		this.selectedEditState = ruleData;
		this.totalDistricts = [];
		this.editStateIndex = stateIndex;
		this.totalStates.push(this.selectedEditState.states);
		this.geographyService.getDistricts(this.selectedEditState.states.code).subscribe(res => {
			this.totalDistricts = res.districts;
			this.formGroup.patchValue(this.selectedEditState);
		},
			(err => {
				console.log(err);
			}));
	}

	updateStateRules() {
		this.rules[this.editStateIndex] = this.formGroup.value;
		this.editStateRule = false;
		this.formGroup.reset();
	}

	editStateRulesCancel() {
		this.editStateRule = false;
		this.formGroup.reset();
	}

	showSelected(item, formControlValue): boolean {
		if (item && formControlValue) {
			return ((item.code === formControlValue.code));
		} else {
			return false;
		}
	}

	// get districts for particular selected state
	getDistricts() {
		this.totalDistricts = [];
		this.formGroup.get('districts').setValue(null);
		const selectedState = this.formGroup.get('state').value;

		if (selectedState.code === 0) {
			this.disableDistricts = true;
			this.formGroup.get('districts').clearValidators();
			this.formGroup.get('districts').updateValueAndValidity();
		} else {
			this.disableDistricts = false;
			this.formGroup.get('districts').setValidators(Validators.required);
			this.formGroup.get('districts').updateValueAndValidity();
			this.geographyService.getDistricts(selectedState.code).subscribe(res => {
				this.totalDistricts = res.districts;
			},
				(err => {
					console.log(err);
				}));
		}

	}

	// add objects to the rules table
	addValuesToTable() {
		this.rules.push(this.formGroup.value);
		const selectedState = this.formGroup.get('state').value;
		if (selectedState.code === 0) {
			for (let i = 0; i < this.totalStates.length; i++) {
				if (selectedState.code === this.totalStates[i].code) {
					this.totalStates.splice(i, 1);
					this.enableAddButton = false;
				}
			}
		} else {
			for (let i = 0; i < this.totalStates.length; i++) {
				if (selectedState.code === this.totalStates[i].code) {
					this.totalStates.splice(i, 1);
				}
			}
		}
		this.control.emit(this.rules);
		this.formGroup.reset();
	}

	// delete row form populated table
	deleteRow(index, deletedRule) {
		if (index === 0) {
			this.rules.splice(index, 1);
			if (deletedRule.code !== 0) {
				this.totalStates.push(deletedRule);
			}
			this.enableAddButton = true;
		} else if (index !== 0) {
			this.rules.splice(index, 1);
			this.totalStates.push(deletedRule);
		}
		this.control.emit(this.rules);
	}

	get editable(){
		return this.options.edit || this.options.add;
	}


	ngOnInit() {
		this.options = this.options || DEFAULT_OPTIONS;
		this.control.emit(this.rules);
		window.scrollTo(0, 0);
		this.getAllStates();
	}

}
